import {Determinant} from "./determinant";
import {GeneralOperatorType} from "./general-operator";

export class DateDeterminant extends Determinant {

  public dateValue: Date;
  public isCurrentDate: boolean;
  public operator: GeneralOperatorType;

}
